import { styled } from "@mui/material/styles";
import { Box, Stack, TextField, Button, Avatar } from "@mui/material";

export const GeneralSettingsBox = styled(Box)({
    width: "100%",
    marginTop: 24,
    padding: 24,
    borderRadius: 8,
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
    backgroundColor: "#fff",
});

export const StyledAvatar = styled(Avatar)({
    width: "4rem",
    height: "4rem",
    fontSize: "1rem",
    marginTop: 24,
    marginBottom: 24,
});

export const StyledStack = styled(Stack)({
    spacing: 16,
});

export const StyledInnerStack = styled(Stack)({});

export const StyledTextField = styled(TextField)({
    maxWidth: 250,
    flexGrow: 1,
});

export const StyledEmailField = styled(TextField)({
    flexGrow: 1,
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'rgba(108, 117, 125, 0.5)',
            borderStyle: 'dashed',
        },
    },
});

export const SaveButton = styled(Button)({
    width: "5rem",
    marginTop: 24,
});
